import { useQuery } from "@tanstack/react-query";
import { api, unwrap } from "./client";
import type { components } from "./schema";

// Přehled Činnost, průvodce START a souhrn dne (M6): agregace na serveru, polling.

type Schemas = components["schemas"];
export type Dashboard = Schemas["DashboardResponse"];
export type DaySummary = Schemas["DaySummaryResponse"];
export type StartStep = Schemas["StartStep"];

export function useDashboard() {
  return useQuery({
    queryKey: ["dashboard"],
    queryFn: async () => unwrap(await api.GET("/api/v1/dashboard")),
    refetchInterval: 30_000,
  });
}

export function useDaySummary() {
  return useQuery({
    queryKey: ["dashboard", "summary"],
    queryFn: async () => unwrap(await api.GET("/api/v1/dashboard/summary")),
    refetchInterval: 30_000,
  });
}
